// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PAABTowyxq2SAF {
  display: flow-root;
  position: relative;
  z-index: 10;
  min-height: 24px;
  padding: var(--ds-space-100, 8px) var(--ds-space-150, 12px) var(--ds-space-050, 4px);
}
.CWT41eJqkazc_h {
  padding-right: var(--ds-space-100, 8px);
}
.MZ7B7UDhi9h321 {
  margin-bottom: var(--ds-space-050, 4px);
}
.BX1WHuavSWLEmb {
  color: var(--ds-text, #172b4d);
  font-size: 11px;
  line-height: 14px;
}
`, ""]);
// Exports
export var details = `PAABTowyxq2SAF`;
export var spinner = `CWT41eJqkazc_h`;
export var aiInProgress = `MZ7B7UDhi9h321`;
export var aiInProgressText = `BX1WHuavSWLEmb`;
export default ___CSS_LOADER_EXPORT___;
